import { render, staticRenderFns } from "./ProviderShowOwner.vue?vue&type=template&id=6b0e5c47"
import script from "./ProviderShowOwner.vue?vue&type=script&lang=js"
export * from "./ProviderShowOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports